if (!customElements.get('shakeram-slideshow')) {
  customElements.define('shakeram-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.location = this.querySelector('[data-location]');
      this.kicker = this.querySelector('[data-current-kicker]');
      this.heading = this.querySelector('[data-current-title]');
      this.caption = this.querySelector('[data-current-caption]');
      this.toggle = this.querySelector('[data-toggle]');
      this.current = 0;
      this.userPaused = false;
      this.delay = Number(this.dataset.interval) || 6500;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelector('[data-previous]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.move(1));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => {
        this.show(index);
        this.restart();
      }));
      this.toggle?.addEventListener('click', () => this.togglePlayback());
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.start();
      });
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());
      this.start();
    }

    show(index) {
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.current;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.location) this.location.textContent = this.slides[this.current].dataset.location;
      if (this.kicker) this.kicker.textContent = this.slides[this.current].dataset.kicker;
      if (this.heading) this.heading.textContent = this.slides[this.current].dataset.title;
      if (this.caption) this.caption.textContent = this.slides[this.current].dataset.caption;
    }

    move(step) {
      this.show(this.current + step);
      this.restart();
    }

    start() {
      if (this.userPaused || this.reducedMotion || document.hidden || this.slides.length < 2) return;
      this.stop();
      this.timer = window.setInterval(() => this.show(this.current + 1), this.delay);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }

    togglePlayback() {
      this.userPaused = !this.userPaused;
      if (this.userPaused) this.stop();
      else this.start();
      this.toggle.textContent = this.userPaused ? 'Play' : 'Pause';
      this.toggle.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
    }
  });
}
